<!-- 中药处方打印组件封装 -->
<template>
  <el-dialog class="print_dialog" title="中药处方预览" :visible.sync="drugVisible" width="640px" top="5vh" :before-close="close" :close-on-click-modal="false">
    <div id="printDrug" class="print_content">
      <div class="header">
        <div class="header_businessName">{{ deptInfo.businessLicenseName }}</div>
        <div class="header_title">处方笺（{{ drugObjs.doseType === '0' ? '饮片' : '颗粒' }}）</div>
        <div v-if="drugObjs.patientInfo" class="header_info">
          <div class="header_item">姓名：{{ drugObjs.patientInfo.patientName }} {{ drugObjs.patientInfo.sex === '1' ? '女' : '男' }} {{ drugObjs.patientInfo.age }}岁{{ drugObjs.patientInfo.ageMth }}月</div>
          <div class="header_item">手机：{{ drugObjs.patientInfo.phone }}</div>
          <div class="header_item">日期：{{ new Date(drugObjs.createTime).Format('yyyy-MM-dd') }}</div>
          <div class="header_item">诊号：{{ drugObjs.uniOrderNumber }}</div>
          <div class="header_item">费别：</div>
          <div class="header_item">诊室：</div>
          <div class="header_item">诊断：{{ drugObjs.editForm.diagnosis }}</div>
        </div>
      </div>
      <div class="drug">
        <div class="drug_title">Rp.</div>
        <div class="drug_list">
          <div v-for="item in drugObjs.items" :key="item.itemId" class="drug_item">
            <div class="drug_tag">
              <span v-if="item.isOwned && item.isOwned === '1'" class="drug_tag_item">[自备]</span>
              <span v-if="![null, undefined, ''].includes(item.handling)" class="drug_tag_item">[{{ item.handling }}]</span>
            </div>
            <div class="drug_info">
              <div class="drug_info_name">{{ item.itemName }}</div>
              <div class="drug_info_dosage">{{ Number(item.itemNum) }}{{ item.itemUnit }}</div>
            </div>
          </div>
        </div>
        <div class="usage">
          <span>用法：{{ drugObjs.recipeMethod || '' }} </span>
          <span>共{{ drugObjs.doseNum }}剂</span>
          <span v-if="drugObjs.doseFrequency">,{{ drugObjs.doseFrequency || '' }}</span>
          <span v-if="drugObjs.frequency">,{{ drugObjs.frequency || '' }}</span>
          <span v-if="drugObjs.takingDosage">,{{ drugObjs.takingDosage || '' }}</span>
          <span v-if="drugObjs.recipeMoment">,{{ drugObjs.recipeMoment || '' }}</span>
          <span v-if="drugObjs.mixingBagNum">,每次{{ drugObjs.mixingBagNum || '' }}袋</span>
          <span v-if="drugObjs.creamDosage">,{{ drugObjs.creamDosage || '' }}</span>
          <span v-if="drugObjs.takingDays">,{{ drugObjs.takingDays || '' }}</span>
          <span v-if="drugObjs.pelletizingDosage">,{{ drugObjs.pelletizingDosage || '' }}</span>
          <span v-if=" drugObjs.applicationTime">,{{ drugObjs.applicationTime || '' }}</span>
          <span v-if="drugObjs.bakingPowderDosage">,{{ drugObjs.bakingPowderDosage || '' }}</span>
          <span v-if="drugObjs.wrapTime">,{{ drugObjs.wrapTime || '' }}</span>
        </div>
        <div class="remark">备注：{{ drugObjs.remark }}</div>
        <div class="process" v-if="drugObjs.ingredients && drugObjs.ingredients.length > 0">
          <span>辅料：</span>
          <span>{{ computedIngredients(drugObjs.ingredients) }}</span>
        </div>
        <div v-if="drugObjs.process" class="process">
          <span>加工：</span>
          <span>{{ drugObjs.process.processName }}</span>
          <span>，{{ drugObjs.doseNum }}剂</span>
          <span v-if="drugObjs.process.processName === '熬药'">，每剂{{ drugObjs.process.bagNum }}袋，共{{ drugObjs.process.bagNumSum }}袋</span>
          <span>；</span>
        </div>
      </div>
      <div v-if="drugObjs.repeatVisitInfo" class="return_remark">
        <span>复诊备注：</span>
        <span v-if="drugObjs.repeatVisitInfo.revisitFlag === '0'">无需复诊</span>
        <span v-if="drugObjs.repeatVisitInfo.revisitFlag === '1'">请在{{ drugObjs.repeatVisitInfo.dateVal }}复诊</span>
        <span v-if="drugObjs.repeatVisitInfo.revisitFlag === '2'">根据病情需要复诊</span>
        <span v-if="drugObjs.repeatVisitInfo.remarkInfo && drugObjs.repeatVisitInfo.remarkInfo.remark">，{{ drugObjs.repeatVisitInfo.remarkInfo.remark }}</span>
      </div>
      <div v-if="drugObjs.editForm && drugObjs.editForm.doctorAdvice" class="advice">
        <div class="advice_label">医嘱：</div>
        <div class="advice_content">{{ drugObjs.editForm.doctorAdvice }}</div>
      </div>
      <div class="tips">-----------以下空白-----------</div>

      <div v-if="this.drugObjs.doctorInfo" class="personnel">
        <div class="personnel_list">
          <div class="personnel_item">医生：{{ this.drugObjs.doctorInfo.doctorName }}</div>
          <div class="personnel_item">审核：</div>
          <div class="personnel_item">调配：</div>
          <div class="personnel_item">核发：</div>
        </div>
        <div class="personnel_tips">除主诊医师特别注明外，处方仅当日有效。按卫生部规定，药房药品一经发出，不得退换</div>
      </div>
    </div>
  </el-dialog>
</template>
  
<script lang="js">

import { doseCanChooseList } from '@/utils/const'
export default {
  props: { print: Function, drugObj: Object, drugVisible: Boolean }, // 接收父组件传递的参数
  created() {
    // this.handDrug();
  },
  watch:{
    drugObj:{
      // immediate:true,
      handler(){
        this.handDrug();
      }
    }
  },
  data() {
    return {
      deptInfo: JSON.parse(sessionStorage.getItem('deptInfo')),
      doseCanChoose: doseCanChooseList,
      drugObjs: {}
    }
  },
  computed:{
    computedIngredients(){
      return function(ingredientsTemplateDetails){
        let res =  ingredientsTemplateDetails.map(v2 => {
          let str = `${v2.oriName}${v2.oriNum}${v2.oriUnit}`;
          if (v2.oriHandling) {
            str += v2.oriHandling;
          }
          return str;
        }).join('，');
        return res
      }
    }
  },
  methods: {
    handDrug() {
      let drug = _.cloneDeep(this.drugObj)
      let noteList = {
        recipeMoment: '',//服用时机
        frequency: '',
        takingDosage: '',
        takingDays: '',
        applicationTime: '',
        wrapTime: '',
        bakingPowderDosage: '',
        creamDosage: '',
        pelletizingDosage: '',
        doseFrequency: '',
        mixingBagNum: '',//冲服
      }
      let list = this.doseCanChoose.filter(val => val.name == drug.recipeMethod)[0].label.map(k => k.id)
      list.forEach(va => {
        noteList[va] = drug[va]
      })
      this.drugObjs = {
        ...drug,
        ...noteList
      }
    },
    // 关闭弹框
    close() {
      this.$emit('closePreview');
    }
  }
}
</script>
<style lang="less" scoped>
  .print_dialog /deep/ .el-dialog__body {
    box-sizing: border-box;
    padding: 20px 20px;
    max-height: 740px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .print_content {
    min-height: 700px;
  }

  .header {
    box-sizing: border-box;
    padding: 0 0 10px 0;
    width: 100%;
    border-bottom: 1px #606266 solid;
    overflow: hidden;
  }

  .header_businessName {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-weight: bold;
    font-size: 20px;
  }

  .header_title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 10px 0 0 0;
    font-size: 18px;
  }

  .header_info {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr;
    grid-gap: 10px;
    margin: 20px 0 0 0;
  }

  .header_item {
    font-size: 14px;
  }

  .drug {
    box-sizing: border-box;
    margin: 20px 0 0 0;
    padding: 0 0 10px 0;
    width: 100%;
    border-bottom: 1px #606266 solid;
  }

  .drug_title {
    font-weight: bold;
    font-size: 14px;
  }

  .drug_list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 10px;
    margin: 10px 0 0 0;
  }

  .drug_item {

  }

  .drug_tag {
    height: 14px;
    line-height: 14px;
  }

  .drug_tag_item {
    font-size: 12px;
  }

  .drug_info {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 4px 0 0 0;
    width: 100%;
    min-height: 28px;
  }

  .drug_info_name {
    white-space: wrap;
    font-size: 14px;
  }

  .drug_info_dosage {
    flex-shrink: 0;
    margin: 0 0 0 10px;
    font-size: 14px;
  }

  .usage {
    margin: 10px 0 0 0;
    font-weight: bold;
    font-size: 14px;
  }

  .remark {
    margin: 6px 0 0 0;
    line-height: 18px;
    font-size: 14px;
  }

  .process {
    margin: 6px 0 0 0;
    line-height: 18px;
    font-size: 14px;
  }

  .return_remark {
    margin: 20px 0 0 0;
    font-size: 14px;
  }

  .advice {
    margin: 10px 0 0 0;
    width: 100%;
  }

  .advice_label {
    font-size: 14px;
  }

  .advice_content {
    margin: 4px 0 0 0;
    line-height: 16px;
    font-size: 14px;
    white-space: pre-wrap;
  }

  .tips {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 0 0;
    width: 100%;
    font-size: 14px;
  }

  .personnel {
    margin: 60px 0 0 0;
    padding: 10px 0 0 0;
    border-top: 1px solid #606266;
  }

  .personnel_list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 10px;
  }

  .personnel_item {
    font-weight: bold;
    font-size: 14px;
  }

  .personnel_tips {
    margin: 10px 0 0 0;
    font-size: 12px;
  }
</style>